import React from 'react';
import { PopoverButton } from 'shared/components/PopoverButton';
import { NewItemFragment } from '../../generated.graphql';


interface Props {
  item: NewItemFragment;
  className?: string;
  caret?: boolean;
}


export const NewProductDescription = (props: Props) => (
  <>
    <p>{props.item.newProductDescription}</p>
    {props.item.modelNumber && 
      <p className="font-weight-bold">Model number: {props.item.modelNumber}</p>
    }
  </>
)


export const NewProductDescriptionButton = (props: Props & {children?: React.ReactNode}) => (
  <PopoverButton buttonText="New product description" className={props.className} caret={props.caret}>
    <div className="small">
      <NewProductDescription item={props.item}/>
    </div>
  </PopoverButton>
)

